export enum VirtualTableSortOrder {
  ASC = "ASC",
  DESC = "DESC"
}
